import {
  Wrapper,
  SubHeading,
  StyledButton,
  Content,
  Coin,
  ZillionnairesTitle,
  StyledTertiaryButton,
  CoinWrapper,
  Star1,
  Star2,
  Star3,
  Star4,
  Star5,
  Star6,
  Star7,
  Star8,
  Star9,
  TitleWrapper,
} from './BlackoutScreen.styles';

const BlackoutScreen = () => (
  <Wrapper>
    <TitleWrapper>
      <ZillionnairesTitle />
    </TitleWrapper>

    <SubHeading variant="h2">We&apos;re polishing our Zs for&nbsp;you!</SubHeading>

    <CoinWrapper>
      <Coin />
      <Star1 />
      <Star2 />
      <Star3 />
      <Star4 />
      <Star5 />
      <Star6 />
      <Star7 />
      <Star8 />
      <Star9 />
    </CoinWrapper>

    <SubHeading variant="h4">Hold on to your socks!</SubHeading>

    <Content variant="body1">
      We&apos;re making some important updates which means you won&apos;t be able to access your
      account for a short while.
    </Content>

    <Content variant="body1">Don&apos;t worry though, we&apos;ll be back very soon!</Content>

    <StyledButton
      href="https://www.zizzi.co.uk/zillionaires-club-faqs"
      fullWidth
      variant="contained"
      disableRipple
      aria-label="faq-button"
    >
      FAQs
    </StyledButton>

    <StyledTertiaryButton href="https://zizzi.co.uk/" aria-label="visit-zizzi-link">
      Visit Zizzi
    </StyledTertiaryButton>
  </Wrapper>
);

export default BlackoutScreen;
